import { currentBreakpoint } from '../utils/windowResize';
import { isTouch } from '../utils/helpers';

export function setupGallery() {
    const galleries = document.querySelectorAll('.gallery__list');

    function initGallery(gallery) {
        const galleryParent = gallery.closest('.gallery');

        if (galleryParent != undefined) {
            const gallerytNext = galleryParent.querySelector('.icon-wrap--next');
            const gallerytPrev = galleryParent.querySelector('.icon-wrap--prev');
            const galleryNavItems = galleryParent.querySelectorAll('.gallery__nav__item');
            const galleryWrap = galleryParent.querySelector('.gallery__list-wrap');

            if (gallerytNext != undefined && galleryWrap != undefined) {
                const minTranslate = ((gallery.offsetWidth - galleryWrap.offsetWidth - 25)) * -1;
                const firstItem = gallery.querySelectorAll('.gallery__item')[0];
                const itemCount = gallery.querySelectorAll('.gallery__item').length;

                let index = 0;
                let startTime = -1;
                let startX = -1;
                let startY = -1;

                let endTime = -1;
                let moveX = -1;
                let moveY = -1;

                let distanceX = -1;
                let direction = -1;
                let time = -1;
                let translateX = -1;
                let moved = false;
                let pxMoved = 0;

                function updateNavList() {
                    const activeItem = Array.prototype.slice.call(galleryNavItems).filter(x => x.classList.contains('js-active'));

                    if (activeItem.length == 1) {
                        const newNavIndex = index;

                        if (newNavIndex < galleryNavItems.length) {
                            const newActiveItem = galleryNavItems[newNavIndex];

                            if (newActiveItem != activeItem[0]) {
                                activeItem[0].classList.remove('js-active');
                                newActiveItem.classList.add('js-active');
                            }
                        }
                    }
                }

                function bounceList() {
                    if (direction == 'left') {
                        gallery.classList.add('js-bounce-left');
                    } else if (direction == 'right') {
                        gallery.classList.add('js-bounce-right');
                    }
                }

                function moveListTo(moveIndex) {
                    index = moveIndex;

                    const newX = ((index) * firstItem.offsetWidth) * -1;
                    gallery.style.transform = `translate3d(${newX}px,0,0`;
                    pxMoved = newX;

                    updateNavList();
                }

                function moveList(e) {
                    if (isTouch && direction != -1) {
                        let newX = -1;

                        if (direction == 'left' && index + 1 < itemCount) {
                            newX = ((index + 1) * firstItem.offsetWidth) * -1;
                            index++;
                        } else if (direction == 'right' && index > 0) {
                            newX = ((index - 1) * firstItem.offsetWidth) * -1;
                            index--;
                        }

                        if (newX != -1) {
                            newX = newX > 0 ? 0 : newX;
                            newX = newX < minTranslate ? minTranslate : newX;

                            gallery.style.transform = `translate3d(${newX}px,0,0`;
                            pxMoved = newX;
                        } else {
                            bounceList();
                        }
                    } else {
                        direction = e.target.closest('.icon-wrap--prev') != undefined ? 'left' : 'right';

                        if (direction == 'left') {
                            if (index > 0) {
                                const newX = ((index - 1) * firstItem.offsetWidth) * -1;
                                pxMoved = newX;

                                gallery.style.transform = `translate3d(${newX}px,0,0`;
                                index--;
                            }
                        } else {
                            if (index + 1 < itemCount) {
                                const newX = ((index + 1) * firstItem.offsetWidth) * -1;
                                pxMoved = newX;

                                gallery.style.transform = `translate3d(${newX}px,0,0`;
                                index++;
                            }
                        }

                        direction = -1;
                    }

                    updateNavList();
                }

                //if (currentBreakpoint == 'xs' || currentBreakpoint == 'xxs') {
                if (isTouch) {
                    function listAnimationEnd() {
                        gallery.classList.remove('js-bounce-left');
                        gallery.classList.remove('js-bounce-right');
                    }

                    function touchStart(e) {
                        if (e.touches.length == 1) {
                            gallery.classList.remove('js-bounce-left');
                            gallery.classList.remove('js-bounce-right');
                            gallery.style.transition = null;
                            startX = e.changedTouches[0].pageX;
                            startY = e.changedTouches[0].pageY;
                            startTime = new Date();
                        }
                    }

                    function touchMove(e) {
                        if (e.touches.length == 1) {
                            moveX = e.targetTouches[0].pageX;
                            moveY = e.targetTouches[0].pageY;

                            distanceX = startX - moveX;
                            let distanceY = startY - moveY;

                            direction = startX > moveX ? 'left' : 'right';

                            distanceX = distanceX < 0 ? distanceX * -1 : distanceX;
                            distanceY = distanceY < 0 ? distanceY * -1 : distanceY;

                            if (distanceX > distanceY) {
                                e.preventDefault();

                                translateX = direction == 'left' ? distanceX * -1 : distanceX;
                                let newTranslateX = translateX + pxMoved;
                                newTranslateX = newTranslateX > 0 ? 0 : newTranslateX;
                                newTranslateX = newTranslateX < minTranslate ? minTranslate : newTranslateX;

                                gallery.style.transform = `translate3d(${newTranslateX}px,0,0)`;

                                moved = true;
                                translateX = newTranslateX;
                            }
                        }
                    }

                    function touchEnd(e) {
                        if (moved) {
                            pxMoved = translateX;

                            endTime = new Date();
                            time = (endTime.getTime() - startTime.getTime()) / 1000;

                            //if (currentBreakpoint == 'xxs' || currentBreakpoint == 'xs') {
                            if (isTouch) {
                                moveList();
                            }

                            startTime = -1;
                            startX = -1;
                            startY = -1;

                            endTime = -1;
                            moveX = -1;
                            moveY = -1;

                            distanceX = -1;
                            direction = -1;
                            time = -1;
                            translateX = -1;
                            moved = false;
                        }
                    }

                    function touchCancel(e) {
                        startTime = -1;
                        startX = -1;
                        startY = -1;

                        endTime = -1;
                        moveX = -1;
                        moveY = -1;

                        distanceX = -1;
                        direction = -1;
                        time = -1;
                        translateX = -1;
                        moved = false;
                    }

                    gallery.addEventListener('animationend', listAnimationEnd);
                    gallery.addEventListener('touchstart', touchStart, {passive: true});
                    gallery.addEventListener('touchmove', touchMove);
                    gallery.addEventListener('touchend', touchEnd, {passive: true});
                    gallery.addEventListener('touchcancel', touchCancel);
                }

                gallerytPrev.addEventListener('click', moveList);
                gallerytNext.addEventListener('click', moveList);

                function clickNavItem(e) {
                    const navItem = e.target.closest('.gallery__nav__item');
                    const clickedIndex = Array.prototype.slice.call(galleryNavItems).indexOf(navItem);

                    moveListTo(clickedIndex);
                }

                for (let a = 0, l = galleryNavItems.length; a < l; a++) {
                    galleryNavItems[a].addEventListener('click', clickNavItem);
                }
            }
        }
    }

    for (let a = 0, l = galleries.length; a < l; a++) {
        initGallery(galleries[a]);
    }
}